import type { Theme } from '@mui/material';

export const styles = {
  checkbox: (theme: Theme) => ({
    pt: 1.25,
    pr: 2,
    pb: 1.25,
    pl: 1,
    color: theme.colors.neutral[100],
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-checked': {
      color: theme.colors.primary[600],
    },
    svg: {
      width: '20px',
      height: '20px',
    },
  }),
  formLabel: (theme: Theme) => ({
    ml: -1.25,
    '& .MuiTypography-root': {
      ...theme.typography.body1,
      color: theme.colors.neutral[600],
      fontWeight: 600,
    },
  }),
};
